import React from 'react';
import PropTypes from 'prop-types';

export const cmsLinkProps = {
    url: PropTypes.string,
    target: PropTypes.string,
    linkText: PropTypes.string,
    onClick: PropTypes.func,
    isAccountApp: PropTypes.bool,
    useExternalLinkIcon: PropTypes.bool,
    className: PropTypes.string
};